const honeepotCustomElementNodeName = 'ODYSSEUS-ENTRY';

const getHoneepotCustomElement = (): Element | undefined => {
  return document.getElementsByTagName(honeepotCustomElementNodeName)[0];
};

export const wrapHoneepotCustomElement = (wrapperElement: HTMLElement) => {
  const honeepotCustomElement = getHoneepotCustomElement();
  if (honeepotCustomElement) {
    wrapperElement.append(honeepotCustomElement);
  }
};
